import type { ExportColumnKeys } from "@/modules/export";
import type { FinanceiroObrasColumnKey } from "./financeiro-obras.types";

/**
 * Chave do contrato de `GET /api/financeiro/obras/exportacao` por coluna; a lupa não é exportável.
 * Condição, Realizado, Outlook, RE, EM, CO, ES e NC ficam `null` de propósito: o core rejeita coluna
 * desconhecida e ainda não as exporta. Quando o core aceitar, troque o `null` pela chave de cada uma.
 */
export const FINANCEIRO_EXPORT_COLUMN_KEYS: ExportColumnKeys<FinanceiroObrasColumnKey> = {
  id: "id",
  embarcacao: "embarcacao",
  statusFinanceiro: "statusFinanceiro",
  tipoObra: "tiposObra",
  realizado: null,
  outlook: null,
  re: null,
  em: null,
  co: null,
  es: null,
  nc: null,
  condicao: null,
  inicio: "inicio",
  termino: "termino",
  duracao: "duracaoTotal",
  detalhamento: null,
};
